import React, { useState, useRef, useEffect } from 'react';
import ComponentLog from '@/components/component-log';
import './index.less';

const INIT = undefined;
const DOWN2TOP = 1;
const TOP2DOWN = 2;

export default React.forwardRef(function ConditionsIndex(props, ref) {
  const { onChange = () => {}, value, options = {}, getlog = () => {} } = props;
  const { valueDown2Top = DOWN2TOP, valueTop2Down = TOP2DOWN, valueInit = INIT } = options;
  const [state, setState] = useState(value);
  const refOnChange = useRef(onChange);

  useEffect(() => {
    setState(value);
  }, [value]);

  // 每次都拿到最新的onChange
  refOnChange.current = onChange;

  const context = useRef(value === valueInit ? init : value === valueDown2Top ? top2Down : down2Top);

  // 重置当前状态
  if (value !== valueDown2Top && valueTop2Down !== value) {
    context.current = init;
  }

  // 状态模式的应用
  function init() {
    const _state = valueDown2Top;
    setState(_state);
    context.current = top2Down;
    refOnChange.current(_state);
  }

  function top2Down() {
    const _state = valueTop2Down;
    setState(_state);
    context.current = down2Top;
    refOnChange.current(_state);
  }

  function down2Top() {
    const _state = valueInit;
    setState(_state);
    context.current = init;
    refOnChange.current(_state);
  }

  function handleUpdateState() {
    context.current();
  }

  return (
    <ComponentLog>
      <div
        key={value} // 因为埋点的bug这里要加上key: 不加上key在clstag更新的时候上报有问题，第一次更新不能上报
        clstag={getlog(value)}
        onClick={handleUpdateState}
        className={'condition-index ' + (state === valueDown2Top ? 'down' : state === valueTop2Down ? 'top' : '')}
      >
        {props.children}
        <span className="arrow-top" />
        <span className="arrow-bottom" />
      </div>
    </ComponentLog>
  );
});
